import MarkList from './markList.js';
import MarkForm from './form';

export default () => {
  return {
    menuOptions: [
      {
        icon: 'list',
        label: '标注列表',
        from: 'right',
        target: 'mark-list',
      },
    ],
    components: [
      {
        id: 'mark-list',
        component: MarkList,
      },
      {
        id: 'mark-form',
        component: MarkForm,
      },
    ],
    defaultContext: ['VIEWER'],
  };
};
